import { Link } from 'react-router-dom';

export default function ComparisonSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Superbuy Spreadsheet vs Alternatives
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            See why organized spreadsheet shopping outperforms traditional product research methods
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b-2 border-background-200">
                <th className="py-4 pr-6 text-sm font-label font-semibold text-foreground-800">Method</th>
                <th className="py-4 pr-6 text-sm font-label font-semibold text-foreground-800 text-center">Speed</th>
                <th className="py-4 pr-6 text-sm font-label font-semibold text-foreground-800 text-center">Organization</th>
                <th className="py-4 text-sm font-label font-semibold text-foreground-800 text-center">Beginner Friendly</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              <tr className="border-b border-background-100">
                <td className="py-4 pr-6 font-medium text-foreground-700">
                  <i className="ri-google-line mr-2 text-foreground-400"></i>
                  Google Search
                </td>
                <td className="py-4 pr-6 text-center text-foreground-500">
                  <span className="inline-block px-3 py-1 bg-accent-100/50 text-accent-700 rounded-full text-xs font-label font-medium">Moderate</span>
                </td>
                <td className="py-4 pr-6 text-center text-foreground-500">
                  <i className="ri-close-circle-line text-accent-500 text-lg"></i>
                </td>
                <td className="py-4 text-center text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                </td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-4 pr-6 font-medium text-foreground-700">
                  <i className="ri-instagram-line mr-2 text-foreground-400"></i>
                  Social Media
                </td>
                <td className="py-4 pr-6 text-center text-foreground-500">
                  <span className="inline-block px-3 py-1 bg-accent-100/50 text-accent-700 rounded-full text-xs font-label font-medium">Slow</span>
                </td>
                <td className="py-4 pr-6 text-center text-foreground-500">
                  <i className="ri-close-circle-line text-accent-500 text-lg"></i>
                </td>
                <td className="py-4 text-center text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                </td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-4 pr-6 font-medium text-foreground-700">
                  <i className="ri-link-m mr-2 text-foreground-400"></i>
                  Random Links
                </td>
                <td className="py-4 pr-6 text-center text-foreground-500">
                  <i className="ri-close-circle-line text-accent-500 text-lg"></i>
                </td>
                <td className="py-4 pr-6 text-center text-foreground-500">
                  <i className="ri-close-circle-line text-accent-500 text-lg"></i>
                </td>
                <td className="py-4 text-center text-foreground-500">
                  <span className="inline-block px-3 py-1 bg-accent-100/50 text-accent-700 rounded-full text-xs font-label font-medium">Risky</span>
                </td>
              </tr>
              <tr>
                <td className="py-4 pr-6 font-bold text-primary-600">
                  <i className="ri-grid-line mr-2 text-primary-500"></i>
                  Superbuy Spreadsheet
                </td>
                <td className="py-4 pr-6 text-center">
                  <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-label font-bold">Fast</span>
                </td>
                <td className="py-4 pr-6 text-center">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg"></i>
                </td>
                <td className="py-4 text-center">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Disclaimer */}
        <div className="mt-16 bg-background-100 rounded-2xl p-8 md:p-10 text-center">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100/50 flex items-center justify-center">
            <i className="ri-information-line text-xl text-accent-600"></i>
          </div>
          <p className="text-foreground-500 text-sm leading-relaxed max-w-2xl mx-auto">
            <strong className="text-foreground-700">Important Disclaimer:</strong> Superbuy Spreadsheet Hub is an independent informational resource created to help users research and understand spreadsheet-based product discovery. We are not affiliated with or endorsed by any official Superbuy services. All external links direct to third-party websites. Always exercise caution and verify information before making purchases.
          </p>
        </div>
      </div>
    </section>
  );
}